if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.initAddons();
      }

      initAddons() {
        const container = this.closest('product-info');
        if (!container) return;
        this.addonCheckboxes = Array.from(container.querySelectorAll('[data-cbd-addons] .cbd-addons__checkbox'));
        if (this.addonCheckboxes.length === 0) return;

        this.dynamicCheckout = this.querySelector('.shopify-payment-button');

        this.addonCheckboxes.forEach((checkbox) => {
          const item = checkbox.closest('.cbd-addons__item');
          const qtyInput = item ? item.querySelector('[data-addon-qty-input]') : null;
          const qtyControl = item ? item.querySelector('[data-cbd-addon-qty]') : null;

          checkbox.addEventListener('change', () => {
            this.toggleAddonQty(checkbox, qtyInput, qtyControl);
            this.updateDynamicCheckoutState();
          });

          if (qtyControl) {
            qtyControl.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((button) => {
              button.addEventListener('click', () => {
                if (!qtyInput || qtyInput.disabled) return;
                const step = button.hasAttribute('data-qty-plus') ? 1 : -1;
                const min = parseInt(qtyInput.min, 10) || 1;
                let value = (parseInt(qtyInput.value, 10) || min) + step;
                if (value < min) value = min;
                qtyInput.value = value;
              });
            });
          }

          this.toggleAddonQty(checkbox, qtyInput, qtyControl);
        });

        this.updateDynamicCheckoutState();
      }

      toggleAddonQty(checkbox, qtyInput, qtyControl) {
        const checked = checkbox.checked;
        if (qtyControl) qtyControl.classList.toggle('is-active', checked);
        if (!qtyInput) return;

        qtyInput.disabled = !checked;
        const buttons = qtyControl ? qtyControl.querySelectorAll('.cbd-addons__qty-btn') : [];
        buttons.forEach((button) => {
          button.disabled = !checked;
        });

        if (checked) {
          qtyInput.value = this.getMainQuantity();
        }
      }

      getMainQuantity() {
        const quantityField = this.form.elements ? this.form.elements['quantity'] : null;
        let quantity = parseInt(quantityField && quantityField.value, 10);
        if (!quantity || quantity < 1) quantity = 1;
        return quantity;
      }

      updateDynamicCheckoutState() {
        if (!this.dynamicCheckout) return;
        const anyChecked = this.addonCheckboxes.some((checkbox) => checkbox.checked);
        this.dynamicCheckout.style.display = anyChecked ? 'none' : '';
      }

      getCheckedAddons() {
        const container = this.closest('product-info') || document;
        return Array.from(container.querySelectorAll('[data-cbd-addons] .cbd-addons__checkbox:checked'));
      }

      buildAddonsBody(checkedAddons) {
        const formData = new FormData(this.form);
        const mainVariantId = formData.get('id');

        const mainQuantity = this.getMainQuantity();

        const mainProperties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) mainProperties[match[1]] = value;
        }
        const sellingPlan = formData.get('selling_plan');

        const mainItem = { id: mainVariantId, quantity: mainQuantity };
        if (Object.keys(mainProperties).length > 0) mainItem.properties = mainProperties;
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        const container = this.closest('product-info') || document;
        const addonsRoot = container.querySelector('[data-cbd-addons]');
        const fallbackTitle = (addonsRoot && addonsRoot.dataset.mainProductTitle) || '';

        const items = [mainItem];
        checkedAddons.forEach((checkbox) => {
          const targetTitle = checkbox.dataset.addonMainTitle || fallbackTitle;
          const item = checkbox.closest('.cbd-addons__item');
          const qtyInput = item ? item.querySelector('[data-addon-qty-input]') : null;
          let addonQuantity = parseInt(qtyInput && qtyInput.value, 10);
          if (!addonQuantity || addonQuantity < 1) addonQuantity = 1;
          items.push({
            id: checkbox.value,
            quantity: addonQuantity,
            properties: { '対象商品': targetTitle },
          });
        });

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }
        return { mainVariantId, body };
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const checkedAddons = this.getCheckedAddons();

        let addedVariantId;
        if (checkedAddons.length > 0) {
          const payload = this.buildAddonsBody(checkedAddons);
          addedVariantId = payload.mainVariantId;
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload.body);
          if (this.cart) this.cart.setActiveElement(document.activeElement);
        } else {
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          addedVariantId = formData.get('id');
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items && response.key == null && response.items.length > 0) {
              response.key = response.items[0].key;
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: addedVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: addedVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
